var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo40X40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_157_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 40C15.2052 40 10.8046 38.3127 7.35938 35.4997C10.4715 33.9362 14.7562 32.5 19.9999 32.5C25.2437 32.5 29.5285 33.9362 32.6404 35.4997C29.1952 38.3127 24.7946 40 19.9999 40Z",
    fill: "#FFC801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.154785 22.5C0.581226 25.9198 1.87106 29.0715 3.79926 31.73C3.90326 31.6718 4.00866 31.6135 4.11541 31.5553C7.82886 29.5298 13.2388 27.5 20.0001 27.5C26.7613 27.5 32.1713 29.5298 35.8846 31.5553C35.9916 31.6135 36.0968 31.6718 36.2008 31.73C38.1291 29.0715 39.4188 25.9198 39.8453 22.5H0.154785Z",
    fill: "#2C444E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79924 8.27007C1.87104 10.9286 0.581224 14.0802 0.154785 17.5H39.8453C39.4188 14.0802 38.1291 10.9285 36.2008 8.27002C36.0968 8.32824 35.9913 8.38649 35.8846 8.44474C32.1711 10.4702 26.7613 12.5 20 12.5C13.2387 12.5 7.82879 10.4702 4.11534 8.44474C4.00861 8.38652 3.90324 8.32827 3.79924 8.27007Z",
    fill: "#2C444E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6405 4.50028C29.5285 6.0637 25.2437 7.5 19.9999 7.5C14.7561 7.5 10.4715 6.06372 7.35938 4.50033C10.8046 1.68722 15.2053 0 20 0C24.7947 0 29.1952 1.6872 32.6405 4.50028Z",
    fill: "#FFC801"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_157_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo40X40);
export default __webpack_public_path__ + "static/media/logo40x40.7cba6c67cb88d602f4b52a3d4014d9ac.svg";
export { ForwardRef as ReactComponent };